// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TasksPage_pageWrap__Gu4Fd .TasksPage_pageHeader__a-NGr {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-bottom: 1px solid var(--border);
  margin-bottom: 16px;
}
.TasksPage_pageWrap__Gu4Fd .TasksPage_pageHeader__a-NGr h1 {
  font: var(--h3);
  font-weight: 700;
  color: var(--primary-Text);
  font-family: var(--font-bodoni-72);
}
.TasksPage_pageWrap__Gu4Fd .TasksPage_pageHeader__a-NGr .TasksPage_right__mSla9 {
  display: flex;
  align-items: center;
  gap: 20px;
}
.TasksPage_pageWrap__Gu4Fd .TasksPage_pageHeader__a-NGr .TasksPage_right__mSla9 .TasksPage_date__O0YT3 {
  display: flex;
  align-items: center;
  gap: 4px;
}
.TasksPage_pageWrap__Gu4Fd .TasksPage_pageHeader__a-NGr .TasksPage_right__mSla9 .TasksPage_date__O0YT3 img,
.TasksPage_pageWrap__Gu4Fd .TasksPage_pageHeader__a-NGr .TasksPage_right__mSla9 .TasksPage_date__O0YT3 svg {
  width: 16px;
  height: 16px;
  object-fit: scale-down;
  display: block;
}
.TasksPage_pageWrap__Gu4Fd .TasksPage_pageHeader__a-NGr .TasksPage_right__mSla9 .TasksPage_date__O0YT3 span {
  font: var(--body-font-four);
  color: var(--primary-Text);
  display: block;
}
.TasksPage_pageWrap__Gu4Fd .TasksPage_tableWrap__IdcRF {
  padding: 0 24px;
}

.TasksPage_InviteModalInner__hk-pj .TasksPage_csvAddRow__jzCmd {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 5px;
  margin-bottom: 15px;
}
.TasksPage_InviteModalInner__hk-pj .TasksPage_addFieldWrp__0URKL {
  max-height: 300px;
  overflow-y: auto;
}
.TasksPage_InviteModalInner__hk-pj .TasksPage_addFieldRow__hgACl {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 15px;
  margin-bottom: 15px;
  width: 100%;
}
.TasksPage_InviteModalInner__hk-pj .TasksPage_addFieldRow__hgACl .TasksPage_row__XE0nR {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding-top: 2px;
}
.TasksPage_InviteModalInner__hk-pj .TasksPage_addFieldRow__hgACl .TasksPage_row__XE0nR .TasksPage_input__mKXaW {
  max-width: 287px;
  width: 100%;
}
.TasksPage_InviteModalInner__hk-pj .TasksPage_addFieldRow__hgACl .TasksPage_row__XE0nR .TasksPage_role__NWvUf {
  min-width: 170px;
}
.TasksPage_InviteModalInner__hk-pj .TasksPage_addFieldRow__hgACl .TasksPage_row__XE0nR .TasksPage_deleteBtn__Zk5BN {
  width: 40px;
  height: 40px;
}
.TasksPage_InviteModalInner__hk-pj .TasksPage_addFieldRow__hgACl .TasksPage_row__XE0nR .TasksPage_deleteBtn__Zk5BN button {
  padding: 10px;
}
.TasksPage_InviteModalInner__hk-pj .TasksPage_addFieldRow__hgACl .TasksPage_row__XE0nR > div:first-child {
  flex: 1 1;
}
.TasksPage_InviteModalInner__hk-pj .TasksPage_addFieldRow__hgACl .TasksPage_row__XE0nR > div:first-child .TasksPage_input__mKXaW {
  max-width: 100%;
}

.TasksPage_formWrp__g56BX {
  max-height: 550px;
  overflow-y: auto;
}
.TasksPage_formWrp__g56BX .TasksPage_formField__uyuP\\+ .TasksPage_label__wfbDw {
  font: var(--body-font-three);
  color: var(--secondary-Text);
  display: block;
  margin-bottom: 4px;
}
.TasksPage_formWrp__g56BX .TasksPage_prioritySelect__mfSaz {
  display: flex;
  align-items: center;
  gap: 5px;
  font: var(--body-font-four);
  font-weight: 500;
  text-transform: capitalize;
  color: var(--primary-Text);
}
.TasksPage_formWrp__g56BX .TasksPage_prioritySelect__mfSaz img,
.TasksPage_formWrp__g56BX .TasksPage_prioritySelect__mfSaz svg {
  width: 16px;
  height: 16px;
  object-fit: scale-down;
  display: block;
}
.TasksPage_formWrp__g56BX .TasksPage_fileUploadedList__uDwC2 {
  padding: 12px;
  width: 100%;
  justify-content: flex-start;
}
.TasksPage_formWrp__g56BX .TasksPage_fileUploadedList__uDwC2 span {
  color: var(--brand);
  flex: 1 1;
}

.TasksPage_taskEditModal__f0kb5 .TasksPage_subHeading__Olb8v {
  font-weight: 600;
  font-size: var(--h6);
  color: var(--primary-Text);
  margin-bottom: 20px;
  text-align-last: left;
}

.TasksPage_taskTitleInput__eUATA {
  width: 100%;
  border: 1px solid var(--Stroke-Color, #E8EBEE);
  border-radius: 8px;
  padding: 8px 12px;
  background: #fff;
  font: var(--body-font-three);
  color: #000;
  margin: 0;
  outline: none;
}
.TasksPage_taskTitleInput__eUATA::placeholder {
  color: var(--secondary-Text);
}
.TasksPage_taskTitleInput__eUATA:focus {
  border-color: #7CA6BD;
}

.TasksPage_taskDetailsModal__5XwNn .TasksPage_subHeading__Olb8v {
  font-weight: 600;
  font-size: var(--h6);
  color: var(--primary-Text);
  margin-bottom: 20px;
  text-align-last: left;
}
.TasksPage_taskDetailsModal__5XwNn .TasksPage_assignedToRow__Z38Kf {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-top: 4px;
}
.TasksPage_taskDetailsModal__5XwNn .TasksPage_assignedToRow__Z38Kf li {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 5px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
}
.TasksPage_taskDetailsModal__5XwNn .TasksPage_assignedToRow__Z38Kf li img,
.TasksPage_taskDetailsModal__5XwNn .TasksPage_assignedToRow__Z38Kf li svg {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}
.TasksPage_taskDetailsModal__5XwNn .TasksPage_dueDate__QZdGD {
  font-weight: 500;
  font-size: var(--body-font-three);
  color: var(--primary-Text);
}
.TasksPage_taskDetailsModal__5XwNn .TasksPage_status__ZRvIt {
  background-color: var(--white);
}
.TasksPage_taskDetailsModal__5XwNn .TasksPage_comment__Qzy6x {
  font-weight: 500;
  font-size: var(--body-font-three);
  color: var(--primary-Text);
}
.TasksPage_taskDetailsModal__5XwNn .TasksPage_fileUploadedList__uDwC2 span {
  color: var(--primary-Text);
}

.TasksPage_deleteModal__WZvmt .TasksPage_modalBtns__aoBV7 {
  display: flex;
  justify-content: center;
  gap: 16px;
}

@media (max-height: 820px) {
  .TasksPage_formWrp__g56BX {
    max-height: 450px;
    overflow-y: auto;
  }
}
@media (max-width: 767px) {
  .TasksPage_pageWrap__Gu4Fd .TasksPage_pageHeader__a-NGr {
    padding: 16px;
  }
  .TasksPage_pageWrap__Gu4Fd .TasksPage_pageHeader__a-NGr .TasksPage_right__mSla9 {
    gap: 12px;
  }
  .TasksPage_pageWrap__Gu4Fd .TasksPage_pageHeader__a-NGr .TasksPage_right__mSla9 button {
    min-height: 35px;
    padding: 7px 10px;
    font-size: 12px;
    text-align: center;
  }
  .TasksPage_pageWrap__Gu4Fd .TasksPage_tableWrap__IdcRF {
    padding: 0 16px;
  }
  .TasksPage_InviteModalInner__hk-pj .TasksPage_csvAddRow__jzCmd button {
    font-size: 12px !important;
  }
}
@media (max-width: 600px) {
  .TasksPage_InviteModalInner__hk-pj .TasksPage_addFieldRow__hgACl .TasksPage_row__XE0nR {
    flex-wrap: wrap;
  }
  .TasksPage_InviteModalInner__hk-pj .TasksPage_addFieldRow__hgACl .TasksPage_row__XE0nR .TasksPage_role__NWvUf {
    order: 3;
    width: 100%;
  }
  .TasksPage_InviteModalInner__hk-pj .TasksPage_addFieldRow__hgACl .TasksPage_row__XE0nR .TasksPage_deleteBtn__Zk5BN {
    width: 35px;
    height: 35px;
    flex-shrink: 0;
  }
  .TasksPage_InviteModalInner__hk-pj .TasksPage_addFieldRow__hgACl .TasksPage_row__XE0nR .TasksPage_deleteBtn__Zk5BN button {
    min-height: auto;
    width: 100%;
    padding: 2px;
    height: 100%;
  }
  .TasksPage_InviteModalInner__hk-pj .TasksPage_row__XE0nR > div:first-child {
    flex: 1 1;
  }
  .TasksPage_InviteModalInner__hk-pj .TasksPage_row__XE0nR > div:first-child .TasksPage_input__mKXaW {
    max-width: 100%;
  }
}
@media (max-width: 425px) {
  .TasksPage_pageWrap__Gu4Fd .TasksPage_pageHeader__a-NGr .TasksPage_right__mSla9 .TasksPage_date__O0YT3 span {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/tasks/TasksPage.module.scss"],"names":[],"mappings":"AACC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,sCAAA;EACA,mBAAA;AAAF;AAEE;EACC,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,kCAAA;AAAH;AAGE;EACC,aAAA;EACA,mBAAA;EACA,SAAA;AADH;AAGG;EACC,aAAA;EACA,mBAAA;EACA,QAAA;AADJ;AAGI;;EAEC,WAAA;EACA,YAAA;EACA,sBAAA;EACA,cAAA;AADL;AAII;EACC,2BAAA;EACA,0BAAA;EACA,cAAA;AAFL;AAQC;EACC,eAAA;AANF;;AAWC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;AARF;AAWC;EACC,iBAAA;EACA,gBAAA;AATF;AAYC;EACC,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,WAAA;AAVF;AAYE;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;EACA,gBAAA;AAVH;AAYG;EACC,gBAAA;EACA,WAAA;AAVJ;AAaG;EACC,gBAAA;AAXJ;AAcG;EACC,WAAA;EACA,YAAA;AAZJ;AAcI;EACC,aAAA;AAZL;AAiBE;EACC,SAAA;AAfH;AAiBG;EACC,eAAA;AAfJ;;AAqBA;EACC,iBAAA;EACA,gBAAA;AAlBD;AAqBE;EACC,4BAAA;EACA,4BAAA;EACA,cAAA;EACA,kBAAA;AAnBH;AAuBC;EACC,aAAA;EACA,mBAAA;EACA,QAAA;EACA,2BAAA;EACA,gBAAA;EACA,0BAAA;EACA,0BAAA;AArBF;AAuBE;;EAEC,WAAA;EACA,YAAA;EACA,sBAAA;EACA,cAAA;AArBH;AAyBC;EACC,aAAA;EACA,WAAA;EACA,2BAAA;AAvBF;AAyBE;EACC,mBAAA;EACA,SAAA;AAvBH;;AA6BC;EACC,gBAAA;EACA,oBAAA;EACA,0BAAA;EACA,mBAAA;EACA,qBAAA;AA1BF;;AA8BA;EACC,WAAA;EACA,8CAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,4BAAA;EACA,WAAA;EACA,SAAA;EACA,aAAA;AA3BD;AA6BC;EACC,4BAAA;AA3BF;AA8BC;EACC,qBAAA;AA5BF;;AAiCC;EACC,gBAAA;EACA,oBAAA;EACA,0BAAA;EACA,mBAAA;EACA,qBAAA;AA9BF;AAiCC;EACC,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AA/BF;AAiCE;EACC,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AA/BH;AAiCG;;EAEC,WAAA;EACA,YAAA;EACA,cAAA;EACA,iBAAA;AA/BJ;AAoCC;EACC,gBAAA;EACA,iCAAA;EACA,0BAAA;AAlCF;AAqCC;EACC,8BAAA;AAnCF;AAsCC;EACC,gBAAA;EACA,iCAAA;EACA,0BAAA;AApCF;AAwCE;EACC,0BAAA;AAtCH;;AA4CC;EACC,aAAA;EACA,uBAAA;EACA,SAAA;AAzCF;;AA6CA;EACC;IACC,iBAAA;IACA,gBAAA;EA1CA;AACF;AA6CA;EAEE;IACC,aAAA;EA5CD;EA8CC;IACC,SAAA;EA5CF;EA8CE;IACC,gBAAA;IACA,iBAAA;IACA,eAAA;IACA,kBAAA;EA5CH;EAiDA;IACC,eAAA;EA/CD;EAqDC;IACC,0BAAA;EAnDF;AACF;AAwDA;EAGG;IACC,eAAA;EAxDF;EA0DE;IACC,QAAA;IACA,WAAA;EAxDH;EA2DE;IACC,WAAA;IACA,YAAA;IACA,cAAA;EAzDH;EA2DG;IACC,gBAAA;IACA,WAAA;IACA,YAAA;IACA,YAAA;EAzDJ;EA+DA;IACC,SAAA;EA7DD;EA+DC;IACC,eAAA;EA7DF;AACF;AAkEA;EAKK;IACC,aAAA;EApEJ;AACF","sourcesContent":[".pageWrap {\r\n\t.pageHeader {\r\n\t\tdisplay: flex;\r\n\t\tjustify-content: space-between;\r\n\t\talign-items: center;\r\n\t\tpadding: 16px 24px;\r\n\t\tborder-bottom: 1px solid var(--border);\r\n\t\tmargin-bottom: 16px;\r\n\r\n\t\th1 {\r\n\t\t\tfont: var(--h3);\r\n\t\t\tfont-weight: 700;\r\n\t\t\tcolor: var(--primary-Text);\r\n\t\t\tfont-family: var(--font-bodoni-72);\r\n\t\t}\r\n\r\n\t\t.right {\r\n\t\t\tdisplay: flex;\r\n\t\t\talign-items: center;\r\n\t\t\tgap: 20px;\r\n\r\n\t\t\t.date {\r\n\t\t\t\tdisplay: flex;\r\n\t\t\t\talign-items: center;\r\n\t\t\t\tgap: 4px;\r\n\r\n\t\t\t\timg,\r\n\t\t\t\tsvg {\r\n\t\t\t\t\twidth: 16px;\r\n\t\t\t\t\theight: 16px;\r\n\t\t\t\t\tobject-fit: scale-down;\r\n\t\t\t\t\tdisplay: block;\r\n\t\t\t\t}\r\n\r\n\t\t\t\tspan {\r\n\t\t\t\t\tfont: var(--body-font-four);\r\n\t\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t\t\tdisplay: block;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t.tableWrap {\r\n\t\tpadding: 0 24px;\r\n\t}\r\n}\r\n\r\n.InviteModalInner {\r\n\t.csvAddRow {\r\n\t\tdisplay: flex;\r\n\t\tjustify-content: space-between;\r\n\t\talign-items: center;\r\n\t\tgap: 5px;\r\n\t\tmargin-bottom: 15px;\r\n\t}\r\n\r\n\t.addFieldWrp {\r\n\t\tmax-height: 300px;\r\n\t\toverflow-y: auto;\r\n\t}\r\n\r\n\t.addFieldRow {\r\n\t\tdisplay: flex;\r\n\t\tflex-direction: column;\r\n\t\tjustify-content: space-between;\r\n\t\talign-items: center;\r\n\t\tgap: 15px;\r\n\t\tmargin-bottom: 15px;\r\n\t\twidth: 100%;\r\n\r\n\t\t.row {\r\n\t\t\tdisplay: flex;\r\n\t\t\tjustify-content: space-between;\r\n\t\t\talign-items: center;\r\n\t\t\tgap: 8px;\r\n\t\t\twidth: 100%;\r\n\t\t\tpadding-top: 2px;\r\n\r\n\t\t\t.input {\r\n\t\t\t\tmax-width: 287px;\r\n\t\t\t\twidth: 100%;\r\n\t\t\t}\r\n\r\n\t\t\t.role {\r\n\t\t\t\tmin-width: 170px;\r\n\t\t\t}\r\n\r\n\t\t\t.deleteBtn {\r\n\t\t\t\twidth: 40px;\r\n\t\t\t\theight: 40px;\r\n\r\n\t\t\t\tbutton {\r\n\t\t\t\t\tpadding: 10px;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.row > div:first-child {\r\n\t\t\tflex: 1;\r\n\r\n\t\t\t.input {\r\n\t\t\t\tmax-width: 100%;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n.formWrp {\r\n\tmax-height: 550px;\r\n\toverflow-y: auto;\r\n\r\n\t.formField {\r\n\t\t.label {\r\n\t\t\tfont: var(--body-font-three);\r\n\t\t\tcolor: var(--secondary-Text);\r\n\t\t\tdisplay: block;\r\n\t\t\tmargin-bottom: 4px;\r\n\t\t}\r\n\t}\r\n\r\n\t.prioritySelect {\r\n\t\tdisplay: flex;\r\n\t\talign-items: center;\r\n\t\tgap: 5px;\r\n\t\tfont: var(--body-font-four);\r\n\t\tfont-weight: 500;\r\n\t\ttext-transform: capitalize;\r\n\t\tcolor: var(--primary-Text);\r\n\r\n\t\timg,\r\n\t\tsvg {\r\n\t\t\twidth: 16px;\r\n\t\t\theight: 16px;\r\n\t\t\tobject-fit: scale-down;\r\n\t\t\tdisplay: block;\r\n\t\t}\r\n\t}\r\n\r\n\t.fileUploadedList {\r\n\t\tpadding: 12px;\r\n\t\twidth: 100%;\r\n\t\tjustify-content: flex-start;\r\n\r\n\t\tspan {\r\n\t\t\tcolor: var(--brand);\r\n\t\t\tflex: 1;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n.taskEditModal {\r\n\t.subHeading {\r\n\t\tfont-weight: 600;\r\n\t\tfont-size: var(--h6);\r\n\t\tcolor: var(--primary-Text);\r\n\t\tmargin-bottom: 20px;\r\n\t\ttext-align-last: left;\r\n\t}\r\n}\r\n\r\n.taskTitleInput {\r\n\twidth: 100%;\r\n\tborder: 1px solid var(--Stroke-Color, #E8EBEE);\r\n\tborder-radius: 8px;\r\n\tpadding: 8px 12px;\r\n\tbackground: #fff;\r\n\tfont: var(--body-font-three);\r\n\tcolor: #000;\r\n\tmargin: 0;\r\n\toutline: none;\r\n\r\n\t&::placeholder {\r\n\t\tcolor: var(--secondary-Text);\r\n\t}\r\n\r\n\t&:focus {\r\n\t\tborder-color: #7CA6BD;\r\n\t}\r\n}\r\n\r\n.taskDetailsModal {\r\n\t.subHeading {\r\n\t\tfont-weight: 600;\r\n\t\tfont-size: var(--h6);\r\n\t\tcolor: var(--primary-Text);\r\n\t\tmargin-bottom: 20px;\r\n\t\ttext-align-last: left;\r\n\t}\r\n\r\n\t.assignedToRow {\r\n\t\tdisplay: flex;\r\n\t\talign-items: center;\r\n\t\tgap: 16px;\r\n\t\tmargin-top: 4px;\r\n\r\n\t\tli {\r\n\t\t\tdisplay: flex;\r\n\t\t\talign-items: center;\r\n\t\t\tgap: 16px;\r\n\t\t\tmargin-bottom: 5px;\r\n\t\t\twidth: 40px;\r\n\t\t\theight: 40px;\r\n\t\t\tborder-radius: 50%;\r\n\t\t\toverflow: hidden;\r\n\r\n\t\t\timg,\r\n\t\t\tsvg {\r\n\t\t\t\twidth: 100%;\r\n\t\t\t\theight: 100%;\r\n\t\t\t\tdisplay: block;\r\n\t\t\t\tobject-fit: cover;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t.dueDate {\r\n\t\tfont-weight: 500;\r\n\t\tfont-size: var(--body-font-three);\r\n\t\tcolor: var(--primary-Text);\r\n\t}\r\n\r\n\t.status {\r\n\t\tbackground-color: var(--white);\r\n\t}\r\n\r\n\t.comment {\r\n\t\tfont-weight: 500;\r\n\t\tfont-size: var(--body-font-three);\r\n\t\tcolor: var(--primary-Text);\r\n\t}\r\n\r\n\t.fileUploadedList {\r\n\t\tspan {\r\n\t\t\tcolor: var(--primary-Text);\r\n\t\t}\r\n\t}\r\n}\r\n\r\n.deleteModal {\r\n\t.modalBtns {\r\n\t\tdisplay: flex;\r\n\t\tjustify-content: center;\r\n\t\tgap: 16px;\r\n\t}\r\n}\r\n\r\n@media (max-height: 820px) {\r\n\t.formWrp {\r\n\t\tmax-height: 450px;\r\n\t\toverflow-y: auto;\r\n\t}\r\n}\r\n\r\n@media (max-width: 767px) {\r\n\t.pageWrap {\r\n\t\t.pageHeader {\r\n\t\t\tpadding: 16px;\r\n\r\n\t\t\t.right {\r\n\t\t\t\tgap: 12px;\r\n\r\n\t\t\t\tbutton {\r\n\t\t\t\t\tmin-height: 35px;\r\n\t\t\t\t\tpadding: 7px 10px;\r\n\t\t\t\t\tfont-size: 12px;\r\n\t\t\t\t\ttext-align: center;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.tableWrap {\r\n\t\t\tpadding: 0 16px;\r\n\t\t}\r\n\t}\r\n\r\n\t.InviteModalInner {\r\n\t\t.csvAddRow {\r\n\t\t\tbutton {\r\n\t\t\t\tfont-size: 12px !important;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@media (max-width: 600px) {\r\n\t.InviteModalInner {\r\n\t\t.addFieldRow {\r\n\t\t\t.row {\r\n\t\t\t\tflex-wrap: wrap;\r\n\r\n\t\t\t\t.role {\r\n\t\t\t\t\torder: 3;\r\n\t\t\t\t\twidth: 100%;\r\n\t\t\t\t}\r\n\r\n\t\t\t\t.deleteBtn {\r\n\t\t\t\t\twidth: 35px;\r\n\t\t\t\t\theight: 35px;\r\n\t\t\t\t\tflex-shrink: 0;\r\n\r\n\t\t\t\t\tbutton {\r\n\t\t\t\t\t\tmin-height: auto;\r\n\t\t\t\t\t\twidth: 100%;\r\n\t\t\t\t\t\tpadding: 2px;\r\n\t\t\t\t\t\theight: 100%;\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.row > div:first-child {\r\n\t\t\tflex: 1;\r\n\r\n\t\t\t.input {\r\n\t\t\t\tmax-width: 100%;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@media (max-width: 425px) {\r\n\t.pageWrap {\r\n\t\t.pageHeader {\r\n\t\t\t.right {\r\n\t\t\t\t.date {\r\n\t\t\t\t\tspan {\r\n\t\t\t\t\t\tdisplay: none;\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageWrap": `TasksPage_pageWrap__Gu4Fd`,
	"pageHeader": `TasksPage_pageHeader__a-NGr`,
	"right": `TasksPage_right__mSla9`,
	"date": `TasksPage_date__O0YT3`,
	"tableWrap": `TasksPage_tableWrap__IdcRF`,
	"InviteModalInner": `TasksPage_InviteModalInner__hk-pj`,
	"csvAddRow": `TasksPage_csvAddRow__jzCmd`,
	"addFieldWrp": `TasksPage_addFieldWrp__0URKL`,
	"addFieldRow": `TasksPage_addFieldRow__hgACl`,
	"row": `TasksPage_row__XE0nR`,
	"input": `TasksPage_input__mKXaW`,
	"role": `TasksPage_role__NWvUf`,
	"deleteBtn": `TasksPage_deleteBtn__Zk5BN`,
	"formWrp": `TasksPage_formWrp__g56BX`,
	"formField": `TasksPage_formField__uyuP+`,
	"label": `TasksPage_label__wfbDw`,
	"prioritySelect": `TasksPage_prioritySelect__mfSaz`,
	"fileUploadedList": `TasksPage_fileUploadedList__uDwC2`,
	"taskEditModal": `TasksPage_taskEditModal__f0kb5`,
	"subHeading": `TasksPage_subHeading__Olb8v`,
	"taskTitleInput": `TasksPage_taskTitleInput__eUATA`,
	"taskDetailsModal": `TasksPage_taskDetailsModal__5XwNn`,
	"assignedToRow": `TasksPage_assignedToRow__Z38Kf`,
	"dueDate": `TasksPage_dueDate__QZdGD`,
	"status": `TasksPage_status__ZRvIt`,
	"comment": `TasksPage_comment__Qzy6x`,
	"deleteModal": `TasksPage_deleteModal__WZvmt`,
	"modalBtns": `TasksPage_modalBtns__aoBV7`
};
export default ___CSS_LOADER_EXPORT___;
